import { Model } from 'app/model/backendmodel';
import { AdapterRegistry } from './../adapter-registry';
import { IModel } from '../../base/annotation';
import { Metamodel } from 'app/model/base/model';

import { SelfHostedIntegrationRuntime } from 'app/model/integrationRuntime/selfhosted.integrationRuntime';
import { irTypesConst } from 'app/integrationruntime/integrationruntime.constants';
import { Credential, NamedAdapter, ReferenceAdapter } from 'shell-models-lib';
import { stringsAreEqualCaseInsensitive } from 'app/shared/utils/string.util';

@AdapterRegistry.adapter({
    model: Metamodel.modelFor(SelfHostedIntegrationRuntime)
})
export class SelfHostedIntegrationRuntimeAdapter extends NamedAdapter<SelfHostedIntegrationRuntime, Model.IntegrationRuntimeResource> {

    public model(): IModel {
        return Metamodel.modelFor(SelfHostedIntegrationRuntime);
    }

    protected _toResource(ir: SelfHostedIntegrationRuntime): Model.IntegrationRuntimeResource {
        const modelIR = super._toResource(ir) as Model.IntegrationRuntimeResource;

        let modelIRLinkedProperties: Model.LinkedIntegrationRuntimeRbacAuthorization | Model.LinkedIntegrationRuntimeKeyAuthorization;
        if (ir.sharedIROriginalResourceId != null) {
            modelIRLinkedProperties = {
                resourceId: ir.sharedIROriginalResourceId,
                authorizationType: 'Rbac'
            };
            if (ir.credential) {
                modelIRLinkedProperties.credential = ReferenceAdapter.toResource(ir.credential, this.context) as Model.CredentialReference;
            }
        }

        const modelIRTypeProperties: Model.SelfHostedIntegrationRuntimeTypeProperties = {
            linkedInfo: modelIRLinkedProperties,
            subType: ir.subType
        };
        if (ir.subType !== irTypesConst.Linked) {
            modelIRTypeProperties.selfContainedInteractiveAuthoringEnabled = ir.selfContainedInteractiveAuthoringEnabled;
        }

        const modelIRProperties: Model.SelfHostedIntegrationRuntime = {
            type: irTypesConst.SelfHosted,
            description: modelIR.properties ? modelIR.properties.description : undefined,
            typeProperties: modelIRTypeProperties
        };

        modelIR.properties = modelIRProperties;

        return modelIR;
    }

    protected _toModel(modelIRResource: Model.IntegrationRuntimeResource, integrationRuntime?: SelfHostedIntegrationRuntime): SelfHostedIntegrationRuntime {
        if (!integrationRuntime) {
            integrationRuntime = new SelfHostedIntegrationRuntime();
        }
        super._toModel(modelIRResource, integrationRuntime);

        const modelIRResourceProperties: Model.SelfHostedIntegrationRuntime = modelIRResource.properties as Model.SelfHostedIntegrationRuntime;

        const modelIRTypeProperties = modelIRResourceProperties.typeProperties;

        if (modelIRTypeProperties != null) {
            if (modelIRTypeProperties.linkedInfo != null) {
                if (stringsAreEqualCaseInsensitive(modelIRTypeProperties.linkedInfo.authorizationType, 'Rbac')) {
                    const modelIRLinkedProperties = modelIRTypeProperties.linkedInfo as Model.LinkedIntegrationRuntimeRbacAuthorization;
                    integrationRuntime.sharedIROriginalResourceId = modelIRLinkedProperties.resourceId;
                }
                if (modelIRTypeProperties.linkedInfo.credential) {
                    integrationRuntime.credential = ReferenceAdapter.toProxyModel<Credential>(Metamodel.modelFor(Credential), modelIRTypeProperties.linkedInfo.credential, this.context);
                }
            }
            integrationRuntime.selfContainedInteractiveAuthoringEnabled = modelIRTypeProperties.selfContainedInteractiveAuthoringEnabled;

            integrationRuntime.subType = modelIRTypeProperties.subType;
        }

        return integrationRuntime;
    }
}
